import { Expose } from "class-transformer";

export class BasicAuthPreferences {
  @Expose({ name: "auth_user" }) authUser: string;
  /** サーバーからは却ってこない */
  @Expose({ name: "auth_pass" }) authPass?: string;
  @Expose({ name: "private_pages" }) privatePages: string[];
}
